import Button from "components/Button/Button";
import Icon from "components/Icon/Icon";
import styled from "styled-components";

export const Wrapper = styled.div`
  margin: 0 10px 15px;
`;

export const TitleRow = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`;

export const Title = styled.h2`
  font-size: 20px;
  font-weight: 700;
  margin: 0;
`;

export const ToggleButton = styled(Button)`
  display: flex;
  align-items: center;
  gap: 4px;
  padding: 4px 0;
`;

export const ChevronIcon = styled(Icon)<{ $isOpen: boolean }>`
  transition: transform 0.2s ease;
  transform: ${({ $isOpen }) => ($isOpen ? "rotate(0deg)" : "rotate(180deg)")};
  width: 10px;
  height: 10px;
`;

export const YearList = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-top: 10px;
`;
